import { ChangeDetectorRef, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { MsCopyRowModel } from '@/models/tables/ms-copy-row.model';

@Component({
  selector: 'app-dialog-ms-copy-row',
  templateUrl: './dialog-ms-copy-row.component.html',
  styleUrls: ['./dialog-ms-copy-row.component.scss'],
})
export class DialogMsCopyRowComponent {
  modalTrigger: Subject<any>;
  selection: MsCopyRowModel;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, private cdr: ChangeDetectorRef) {
    this.modalTrigger = data.modalTrigger;
    this.selection = data.selection;
  }
}
